import * as i0 from '@angular/core';
import * as i1 from './ui.module';
import * as i2 from '@angular/common';
import * as i3 from './hint/hint.directive';
import * as i4 from './dialog/dialog.component';
import * as i5 from './dialog/dialog-close.directive';
import * as i6 from './expand/bll-expand.component';
import * as i7 from './expand/bll-expand-panel.component';
import * as i8 from './expand/bll-expand-panel-header.component';
import * as i9 from './accordion/accordion.component';
import * as i10 from './accordion/accordion-panel.component';
import * as i11 from './accordion/accordion-header.component';
import * as i12 from './accordion-workflow/accordion-workflow.component';
import * as i13 from './accordion-workflow/accordion-workflow-panel.component';
import * as i14 from './accordion-workflow/accordion-workflow-header.component';
import * as i15 from './checkbox/checkbox.component';
import * as i16 from './radio/radio.component';
import * as i17 from './input/input.component';
import * as i18 from './form-field/error';
import * as i19 from './form-field/form-hint';
import * as i20 from './form-field/form-field.component';
import * as i21 from '@vltansky/ng-select';
import * as i22 from './button/button.component';
import * as i23 from './select/select.component';
import * as i24 from './autocomplete/autocomplete.component';
import * as i25 from './tooltip/tooltip.component';
import * as i26 from './loader/loader.component';
import * as i27 from './skeleton-text/skeleton-text.component';
import * as i28 from '@ng-bootstrap/ng-bootstrap';
import * as i29 from './icon/icon.component';
import * as i30 from './table/table.component';
import * as i31 from './table/table-row.directive';
import * as i32 from './hint/hint.module';
import * as i33 from './dialog/dialog.module';
import * as i34 from './expand/bll-expand.module';
import * as i35 from './accordion/accordion.module';
import * as i36 from './accordion-workflow/accordion-workflow.module';
import * as i37 from './checkbox/checkbox.module';
import * as i38 from './radio/radio.module';
import * as i39 from './input/input.module';
import * as i40 from './form-field/form-field.module';
import * as i41 from './button/button.module';
import * as i42 from './select/select.module';
import * as i43 from './autocomplete/autocomplete.module';
import * as i44 from './tooltip/tooltip.module';
import * as i45 from './loader/loader.module';
import * as i46 from './modal/bll-modal.module';
import * as i47 from './skeleton-text/skeleton-text.module';
import * as i48 from './icon/icon.module';
import * as i49 from './table/table.module';
export const UiModuleNgFactory:i0.NgModuleFactory<i1.UiModule> = (null as any);
var _decl0_0:i2.NgClass = (<any>(null as any));
var _decl0_1:i2.NgComponentOutlet = (<any>(null as any));
var _decl0_2:i2.NgForOf<any,any> = (<any>(null as any));
var _decl0_3:i2.NgIf<any> = (<any>(null as any));
var _decl0_4:i2.NgTemplateOutlet = (<any>(null as any));
var _decl0_5:i2.NgStyle = (<any>(null as any));
var _decl0_6:i2.NgSwitch = (<any>(null as any));
var _decl0_7:i2.NgSwitchCase = (<any>(null as any));
var _decl0_8:i2.NgSwitchDefault = (<any>(null as any));
var _decl0_9:i2.NgPlural = (<any>(null as any));
var _decl0_10:i2.NgPluralCase = (<any>(null as any));
var _decl0_11:i3.BllHintDirective = (<any>(null as any));
var _decl0_12:i4.BllDialogComponent = (<any>(null as any));
var _decl0_13:i5.BllDialogCloseDirective = (<any>(null as any));
var _decl0_14:i6.BllExpandComponent = (<any>(null as any));
var _decl0_15:i7.BllExpandPanelComponent = (<any>(null as any));
var _decl0_16:i8.BllExpandPanelHeaderComponent = (<any>(null as any));
var _decl0_17:i9.BllAccordionComponent = (<any>(null as any));
var _decl0_18:i10.BllAccordionPanelComponent = (<any>(null as any));
var _decl0_19:i11.BllAccordionPanelHeaderComponent = (<any>(null as any));
var _decl0_20:i12.BllAccordionWorkflowComponent = (<any>(null as any));
var _decl0_21:i13.BllAccordionWorkflowPanelComponent = (<any>(null as any));
var _decl0_22:i14.BllAccordionWorkflowHeaderComponent = (<any>(null as any));
var _decl0_23:i15.BllChecboxComponent = (<any>(null as any));
var _decl0_24:i16.BllRadioButton = (<any>(null as any));
var _decl0_25:i16.BllRadioGroup = (<any>(null as any));
var _decl0_26:i17.bllInput = (<any>(null as any));
var _decl0_27:i18.BllError = (<any>(null as any));
var _decl0_28:i19.BllFormHint = (<any>(null as any));
var _decl0_29:i20.BllFormField = (<any>(null as any));
var _decl0_30:i21.NgSelectComponent = (<any>(null as any));
var _decl0_31:i21.ɵr = (<any>(null as any));
var _decl0_32:i21.ɵg = (<any>(null as any));
var _decl0_33:i21.ɵf = (<any>(null as any));
var _decl0_34:i21.ɵh = (<any>(null as any));
var _decl0_35:i21.ɵi = (<any>(null as any));
var _decl0_36:i21.ɵj = (<any>(null as any));
var _decl0_37:i21.ɵk = (<any>(null as any));
var _decl0_38:i21.ɵl = (<any>(null as any));
var _decl0_39:i21.ɵm = (<any>(null as any));
var _decl0_40:i21.ɵn = (<any>(null as any));
var _decl0_41:i21.ɵo = (<any>(null as any));
var _decl0_42:i21.ɵp = (<any>(null as any));
var _decl0_43:i22.bllButton = (<any>(null as any));
var _decl0_44:i22.uiAnchor = (<any>(null as any));
var _decl0_45:i23.BllSelectComponent = (<any>(null as any));
var _decl0_46:i24.BllAutocompleteComponent = (<any>(null as any));
var _decl0_47:i25.BllTooltipComponent = (<any>(null as any));
var _decl0_48:i26.LoaderComponent = (<any>(null as any));
var _decl0_49:i27.BllSkeletonTextComponent = (<any>(null as any));
var _decl0_50:i28.NgbTooltip = (<any>(null as any));
var _decl0_51:i29.BllIconComponent = (<any>(null as any));
var _decl0_52:i30.BllTableComponent = (<any>(null as any));
var _decl0_53:i31.BllTableColumnDirective = (<any>(null as any));
var _decl0_54:i2.AsyncPipe = (<any>(null as any));
var _decl0_55:i2.UpperCasePipe = (<any>(null as any));
var _decl0_56:i2.LowerCasePipe = (<any>(null as any));
var _decl0_57:i2.JsonPipe = (<any>(null as any));
var _decl0_58:i2.SlicePipe = (<any>(null as any));
var _decl0_59:i2.DecimalPipe = (<any>(null as any));
var _decl0_60:i2.PercentPipe = (<any>(null as any));
var _decl0_61:i2.TitleCasePipe = (<any>(null as any));
var _decl0_62:i2.CurrencyPipe = (<any>(null as any));
var _decl0_63:i2.DatePipe = (<any>(null as any));
var _decl0_64:i2.I18nPluralPipe = (<any>(null as any));
var _decl0_65:i2.I18nSelectPipe = (<any>(null as any));
var _decl0_66:i2.KeyValuePipe = (<any>(null as any));
var _decl0_88:i2.CommonModule = (<any>(null as any));
var _decl0_89:i32.BllHintModule = (<any>(null as any));
var _decl0_90:i33.BllDialogModule = (<any>(null as any));
var _decl0_91:i34.BllExpandModule = (<any>(null as any));
var _decl0_92:i35.BllAccordionModule = (<any>(null as any));
var _decl0_93:i36.BllAccordionWorkflowModule = (<any>(null as any));
var _decl0_94:i37.BllCheckboxModule = (<any>(null as any));
var _decl0_95:i38.BllRadioModule = (<any>(null as any));
var _decl0_96:i39.BllInputModule = (<any>(null as any));
var _decl0_97:i40.BllFormFieldModule = (<any>(null as any));
var _decl0_98:i21.NgSelectModule = (<any>(null as any));
var _decl0_99:i41.BllButtonModule = (<any>(null as any));
var _decl0_100:i42.BllSelectModule = (<any>(null as any));
var _decl0_101:i43.BllAutocompleteModule = (<any>(null as any));
var _decl0_102:i44.BllTooltipModule = (<any>(null as any));
var _decl0_103:i45.BllLoaderModule = (<any>(null as any));
var _decl0_104:i46.BllModalModule = (<any>(null as any));
var _decl0_105:i47.BllSkeletonTextModule = (<any>(null as any));
var _decl0_106:i28.NgbTooltipModule = (<any>(null as any));
var _decl0_107:i48.BllIconModule = (<any>(null as any));
var _decl0_108:i49.BllTableModule = (<any>(null as any));
var _decl0_109:i0.TemplateRef<any> = (<any>(null as any));
var _decl0_110:i0.ElementRef<any> = (<any>(null as any));
